import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../ui/SectionHeader';
import TiltCard from '../ui/TiltCard';
import caseStudies from '../../data/caseStudies.json';
import './CaseStudies.css';

const CaseStudies = () => {
  return (
    <section className="work tra-section" id="work">
      <div className="tra-container">
        <SectionHeader
          eyebrow="Sample Campaigns"
          title="How we build a winning campaign"
          subtitle="Illustrative examples showing how we approach different goals for gaming brands — from launches to always-on creator programs."
        />

        <div className="work__list">
          {caseStudies.map((cs, i) => (
            <TiltCard key={cs.slug} delay={i * 0.05}>
              <Link
                to={`/work/${cs.slug}`}
                className="work-card"
                style={{ '--cs-accent': cs.accent }}
              >
                <div className="work-card__media">
                  <img src={process.env.PUBLIC_URL + cs.image} alt={cs.brand} loading="lazy" />
                  <span className="work-card__category">{cs.category}</span>
                </div>

                <div className="work-card__body">
                  <span className="work-card__brand">{cs.brand}</span>
                  <h3 className="work-card__title">{cs.title}</h3>
                  <p className="work-card__summary">{cs.summary}</p>

                  <div className="work-card__results">
                    {cs.results.map((r) => (
                      <div className="work-card__result" key={r.label}>
                        <span className="work-card__result-value">{r.value}</span>
                        <span className="work-card__result-label">{r.label}</span>
                      </div>
                    ))}
                  </div>

                  <span className="work-card__link">
                    View case study <span aria-hidden="true">→</span>
                  </span>
                </div>
              </Link>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
